export const NOTIFY_ENABLED = 'NOTIFY_ENABLED';
export const NOTIFY_FALANDO_DE_GENTE = 'NOTIFY_FALANDO_DE_GENTE';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_BUTTON = 'SHOW_BUTTON';
export const NOTIFY_HEADER = 'NOTIFY_HEADER';
export const NOTIFY_HEADER_MAIS = 'NOTIFY_HEADER_MAIS';
export const NOTIFY_HEADER_FALANDO_DE_GENTE = 'NOTIFY_HEADER_FALANDO_DE_GENTE';
export const NOTIFY_HEADER_FALANDO_DE_GENTE_MAIS = 'NOTIFY_HEADER_FALANDO_DE_GENTE_MAIS';

export const NOTIFY_POST = 'NOTIFY_POST';
export const NOTIFY_POST_MORE = 'NOTIFY_POST_MORE';
export const NOTIFY_POST_PAGINATE = 'NOTIFY_POST_PAGINATE';
export const NOTIFY_LOADING = 'NOTIFY_LOADING';
export const NOTIFY_MORE = 'NOTIFY_MORE';
